import { NgModule } from 'ng-metadata/core';
import {AlmaDigitization} from './almaDigitization';
import {AlmaDigitizationOther} from './almaDigitizationOther';
import {AlmaGeneralDigitization} from "./almaGeneralDigitization";
import {AlmaItemDigitization} from './almaItemDigitization';
import {AlmaItemRequest} from './almaItemRequest';
import {AlmaPurchaseRequest} from './almaPurchaseRequest';
import {AlmaRequest} from './AlmaRequest';
import {AlmaRequestAnyItem} from './AlmaRequestAnyItem';
import {AlmaRequestOther} from './AlmaRequestOther';
import {AlmaResourceSharing} from './almaResourceSharing';

@NgModule({
    declarations: [],
    providers: [
        AlmaDigitization,
        AlmaDigitizationOther,
        AlmaItemDigitization,
        AlmaGeneralDigitization,
        AlmaItemRequest,
        AlmaPurchaseRequest,
        AlmaRequest,
        AlmaRequestAnyItem,
        AlmaRequestOther,
        AlmaResourceSharing
    ],
    imports:[
    ]
})
export class AlmaRequestTypeModule {}


// WEBPACK FOOTER //
// ./src/main/webapp/components/search/fullView/getit/opac/request/requestTypes/alma/almaRequestType.module.ts